import Unchecked from './circle-done.svg';
import Checked from './circle-done-selected.svg';

export const CircleDoneIcon = ({ selected }: { selected: boolean }) => {
	return selected ? <Checked /> : <Unchecked />;
};
